export default "__VITE_ASSET___Toj3sW5__"